// extracted by mini-css-extract-plugin
module.exports = {"rounded_full":"Trends_rounded_full__2-OWJ","chart_legend":"Trends_chart_legend__1SUBJ","chart_title":"Trends_chart_title__1Sx5p","chart_wrapper":"Trends_chart_wrapper__3q0mv"};